import React, { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import {
  Col,
  Row,
  Container,
  Table,
  Pagination,
  PaginationItem,
  PaginationLink,
  ButtonDropdown,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
  Label,
  Badge,
  Card,
  CardTitle,
  CardBody,
  options
} from "reactstrap";
import Select from "react-select";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import mock from "../tables/mock";
import Widget from "../../components/Widget/Widget.js";
import s from "../tables/Tables.module.scss";
import moreIcon from "../../assets/tables/moreIcon.svg";
import Starrating from "../../assets/tables/Start.png";
import "../../button.css"
import { css } from "@emotion/react";
import { ClockLoader } from "react-spinners";
import BaseAPI from '../../api/apiurl.js';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Input, Form, Button, CustomInput } from 'reactstrap';
import { format } from 'date-fns';
import { toast, ToastContainer } from 'react-toastify';
import '../subpages/datepicker.css'






const Complaints = function () {
  const [selectedDate, setSelectedDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [data, setData] = useState([]);
  const [auditOpen, setAuditOpen] = useState(false);
  const [selectid, setSelectid] = useState(null);
  const [feedback, setFeedback] = useState('');
  const [staffname, setStaffnam] = useState([]); // staff droupdown
  // const [selectedstaff, setSelectedstaff] = useState([]);
  const [selecteddepartment, setSelecteddepartment] = useState([]);
  const [departmentDropdown, setDepartmentDropdown] = useState([]);

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleDateChange2 = (date) => {
    setEndDate(date);
  };

  const options = [
    { value: 'Registered', label: 'Registered' },
    { value: 'Planned', label: 'Planned' },
    { value: 'Assigned', label: 'Assigned' },
    { value: 'Rescheduled', label: 'Rescheduled' }
  ]

  const buttonStyle = {
    marginTop: '20px',
    display: 'flex',
    justifyContent: 'center',
  };


  const [firstTable] = useState(mock.firstTable);
  const [secondTable] = useState(mock.secondTable);
  const [secondTableCurrentPage, setSecondTableCurrentPage] = useState(0); //
  const [tableDropdownOpen, setTableMenuOpen] = useState(false); //
  const [isLoading, setIsLoading] = useState(true);
  const [selectedValueStatus, setSelectedValueStatus] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [stageDropdown, setStageDropdown] = useState([]);
  const [tPorjectDropdown, setTPorjectDropdown] = useState([]);
  const [customeDropdown, setCustomeDropdown] = useState([]);
  const [selectStageDropdown, setSelectStageDropdown] = useState(null);
  const [selectTPorjectDropdown, setSelectTPorjectDropdown] = useState(null);
  const [selectCustomeDropdown, setSelectCustomeDropdown] = useState([]);
  const [responseMessage, setResponseMessage] = useState(''); // tost


  const [productOptions, setProductOptions] = useState([]);
  const [selectedProduct, setselectedProduct] = useState([]);

  const [taskOptions, setTaskOptions] = useState([]);
  const [selectedtask, setselectedTask] = useState(null);

  const [customeOption, setCustomeOption] = useState([]);
  const [selectedcustome, setselectedcustome] = useState([]);

  const [Remarktext, setRemarktext] = useState("");

  const [taskKey, setTaskKey] = useState(0);

  const pageSize = 10;
  const secondTablePagesCount = Math.ceil((Array.isArray(data) ? data.length : 0) / pageSize);
 
   const PaginationComponent = () => {
     const pagesToShow = 5;
 
     const startPage = Math.max(0, secondTableCurrentPage - Math.floor(pagesToShow / 2));
     const endPage = Math.min(secondTablePagesCount - 1, startPage + pagesToShow - 1);
 
     return (
       <Pagination className="pagination-with-border">
         <PaginationItem disabled={secondTableCurrentPage <= 0}>
           <PaginationLink
             onClick={(e) => setSecondTablePage(e, secondTableCurrentPage - 1)}
             previous
             href="#top"
           />
         </PaginationItem>
         {[...Array(endPage - startPage + 1)].map((_, i) => (
           <PaginationItem
             key={i}
             active={startPage + i === secondTableCurrentPage}
           >
             <PaginationLink onClick={(e) => setSecondTablePage(e, startPage + i)} href="#top">
               {startPage + i + 1}
             </PaginationLink>
           </PaginationItem>
         ))}
         <PaginationItem disabled={secondTableCurrentPage >= secondTablePagesCount - 1}>
           <PaginationLink
             onClick={(e) => setSecondTablePage(e, secondTableCurrentPage + 1)}
             next
             href="#top"
           />
         </PaginationItem>
       </Pagination>
     );
   };

  const role = localStorage.getItem('role');


  const isRoleTwo = role === '2';


  const auditopenid = (itemId) => {
    setSelectid(itemId);
    setAuditOpen(true);
  };

  const auditClosed = () => {
    setAuditOpen(false);
  };

  const optionsStatus = [
    { value: '1', label: 'Registered' },
    { value: '2', label: 'Planned ' },
    { value: '3', label: 'Completed' }

  ]

  const openmodel = () => {
    setIsModalOpen(true);
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };


  const fetchData = () => {
    const customerId = localStorage.getItem('customerid');
    const companyId = localStorage.getItem('companyid');
    const role = localStorage.getItem('role');
    const Id = localStorage.getItem('id');

    if (!customerId || !companyId) {
      console.log('Missing customer ID or company ID.');
      return;
    }

    const url = `${BaseAPI}auditview`;
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customer_id: customerId, company_id: companyId, role_id: role, id: Id })
    };

    fetch(url, requestOptions)
      .then((response) => response.json())
      .then((actualData) => {
        console.log(actualData);

        setData(actualData.data);
        console.log("response", data);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const fetchDepartment = async () => {
    try {
      const url = `${BaseAPI}projectdepartment`;
      const companyId = localStorage.getItem('companyid');
      const customerId = localStorage.getItem('customerid');
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // You might need to add other headers if required (e.g., authorization headers)
        },
        body: JSON.stringify({
          company_id: companyId,
          customer_id: customerId
        }),

      });

      if (!response.ok) {
        throw new Error('Network response was not ok.');
      }

      const data = await response.json();
      setDepartmentDropdown(data.data.map(item => ({ label: item.departName, value: item.departid })));
    } catch (error) {
      console.error('Error:', error);
      // Handle the error here if needed
    }
  };

  const fetchStage = async (projectId) => {
    try {
      const url = `${BaseAPI}audittasks`;
      const companyId = localStorage.getItem('companyid');
      const customerId = localStorage.getItem('customerid');
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // You might need to add other headers if required (e.g., authorization headers)
        },
        body: JSON.stringify({
          company_id: companyId,
          customer_id: customerId,
          project_id: projectId
        }),

      });

      if (!response.ok) {
        throw new Error('Network response was not ok.');
      }

      const data = await response.json();
      setStageDropdown(data.data.map(item => ({ label: item.tasktitle, value: item.id })));
    } catch (error) {
      console.error('Error:', error);
      // Handle the error here if needed
    }
  };

  const fetchTaskProject = async () => {
    try {
      const url = `${BaseAPI}project`;
      const companyId = localStorage.getItem('companyid');
      const customerId = localStorage.getItem('customerid');
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // You might need to add other headers if required (e.g., authorization headers)
        },
        body: JSON.stringify({
          company_id: companyId,
          customer_id: customerId
        }),

      });

      if (!response.ok) {
        throw new Error('Network response was not ok.');
      }

      const data = await response.json();
      setTPorjectDropdown(data.data.map(item => ({ label: item.entityname, value: item.id })));
    } catch (error) {
      console.error('Error:', error);
      // Handle the error here if needed
    }
  };

  // const fetchCustome = async () => {
  //   try {
  //     const url = `${BaseAPI}customerdrop`;
  //     const companyId = localStorage.getItem('companyid');
  //     const customerId = localStorage.getItem('customerid');
  //     const response = await fetch(url, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         // You might need to add other headers if required (e.g., authorization headers)
  //       },
  //       body: JSON.stringify({
  //         company_id: companyId,
  //         customer_id: customerId
  //       }),

  //     });

  //     if (!response.ok) {
  //       throw new Error('Network response was not ok.');
  //     }

  //     const data = await response.json();
  //     setCustomeDropdown(data.data.map(item => ({ label: item.customername, value: item.id })));
  //     setCustomeOption(data.data.map(item => ({ label: item.customername, value: item.id })));
  //   } catch (error) {
  //     console.error('Error:', error);
  //     // Handle the error here if needed
  //   }
  // };

  const fetchProdect = async () => {
    try {
      const url = `${BaseAPI}project`;
      const companyId = localStorage.getItem('companyid');
      const customerId = localStorage.getItem('customerid');
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // You might need to add other headers if required (e.g., authorization headers)
        },
        body: JSON.stringify({
          company_id: companyId,
          customer_id: customerId
        }),

      });

      if (!response.ok) {
        throw new Error('Network response was not ok.');
      }

      const data = await response.json();
      setProductOptions(data.data.map(item => ({ label: item.entityname, value: item.id })));

    } catch (error) {
      console.error('Error:', error);
      // Handle the error here if needed
    }
  };

  const fetchTask = async (projectId) => {

    try {
      const url = `${BaseAPI}audittasks`;
      const companyId = localStorage.getItem('companyid');
      const customerId = localStorage.getItem('customerid');


      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // You might need to add other headers if required (e.g., authorization headers)
        },
        body: JSON.stringify({
          company_id: companyId,
          customer_id: customerId,
          project_id: projectId // Set the project_id here
        }),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok.');
      }

      const data = await response.json();
      setTaskOptions(data.data.map(item => ({ label: item.tasktitle, value: item.id })));
    } catch (error) {
      console.error('Error:', error);
      // Handle the error here if needed
    }
  };







  const handleAuditReopen = () => {
    const customer_id = localStorage.getItem('customerid');
    const company_id = localStorage.getItem('companyid');
    const itemId = selectid;

    fetch(`${BaseAPI}auditreopen/${itemId}?company_id=${company_id}&customer_id=${customer_id}&servicestatus=2`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        // Add any necessary headers here
      },
      // Add body if required by the API
    })
      .then(response => {
        if (response.ok) {
          // Handle a successful response here

          window.location.reload()

        } else {
          // Handle errors here
          console.error('Failed to Service Cancel');
        }
      })
      .catch(error => {
        // Handle errors, perhaps show an error message
      });
  };


  const setSecondTablePage = (e, index) => {
    e.preventDefault();
    setSecondTableCurrentPage(index);
  }

  const tableMenuOpen = () => {
    setTableMenuOpen(!tableDropdownOpen);
  } //


  const handleSearch = () => {
    const customerId = localStorage.getItem('customerid');
    const companyId = localStorage.getItem('companyid');
  
    if (!customerId || !companyId) {
      console.log('Missing customer ID or company ID.');
      return;
    }
  
    // Check and set empty values to an empty string
    const formattstartdate = selectedDate ? format(selectedDate, 'dd-MM-yyyy') : '';
    const formatenddate = endDate ? format(endDate, 'dd-MM-yyyy') : '';
  
    const customerLabel = selectCustomeDropdown ? selectCustomeDropdown.label || '' : '';
    const stageLabel = selectStageDropdown ? selectStageDropdown.label || '' : '';
    const projectLabel = selectTPorjectDropdown ? selectTPorjectDropdown.label || '' : '';
    const statusValue = selectedValueStatus ? selectedValueStatus.value || '' : '';
  
    const url = `${BaseAPI}auditfilters?company_id=${companyId}&customer_id=${customerId}&customer=${customerLabel}&stage=${stageLabel}&project=${projectLabel}&status=${statusValue}&startdate=${formattstartdate}&enddate=${formatenddate}`;
  
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        if (data.data && data.data.length > 0) {
          setData(data.data);
        } else {
          setData([]);
        }
      })
      .catch((error) => {
        console.error('Error fetching data from API:', error);
      });
  };
  

  const handleCancel = () => {
    fetchData();
    setSelectTPorjectDropdown(null);
    setSelectStageDropdown(null);
    setSelectedValueStatus(null);
    setEndDate(null);
    setSelectedDate(null);
  };

  const handleSubmit = async () => {
    try {
      const url = `${BaseAPI}auditadds`;


      const customerId = localStorage.getItem('customerid');
      const companyId = localStorage.getItem('companyid');
      const formData = new FormData();

      // Append other form fields
      formData.append('company_id', companyId);
      formData.append('customer_id', customerId);
      formData.append('auditdesc', Remarktext);
      formData.append('custuser_id', selectedcustome.value);
      formData.append('projectid', selectedProduct.value);
      formData.append('taskid', selectedtask.value);



      const response = await fetch(url, {
        method: 'POST',
        body: formData, // Use the FormData object
      });

      if (!response.ok) {
        throw new Error('Network response was not ok.');
      }
      const data = await response.json();
      setResponseMessage(data.message);
      toast.success('Audit Data Add Sucessfully', {
        autoClose: 1500,
        position: 'top-center',
        className: 'custom-toast-success', // Apply the custom error class
      });
      await new Promise((resolve) => setTimeout(resolve, 1500));

      // Navigate to the desired route
      toggleModal();

    } catch (error) {
      console.error('Error:', error);
      toast.error('Sorry Data Not Added', {
        autoClose: 1500,
        position: 'top-center',
        className: 'custom-toast-error', // Apply the custom error class
      });
      setResponseMessage('Error occurred while making the API request.');
    }
  };


  useEffect(() => {

    const loadingTimeout = setTimeout(() => {
      setIsLoading(false);
      fetchData();
      // fetchStage();
      fetchTaskProject();
      // fetchCustome();
      fetchProdect();
      // fetchTask();

    }, 2000);

    return () => clearTimeout(loadingTimeout);
  }, []);


  const handleProductChange = async (newValue) => {
    setselectedProduct(newValue);

    try {
      const projectId = newValue && typeof newValue === 'object' ? newValue.value : null;

      if (projectId) {
        // Clear the taskOptions before fetching new tasks
        setTaskOptions([]);
        setselectedTask(null);
        // Increment the key to force remounting of the Select component
        setTaskKey(prevKey => prevKey + 1);

        // Fetch tasks here based on the selected project ID
        await fetchTask(projectId);
      } else {
        console.error('Invalid or missing project ID');
      }
    } catch (error) {
      console.error('Error fetching tasks:', error);
      // Handle errors if needed
    }
  };

  const handelprojectChange = async (newValue) => {
    setSelectTPorjectDropdown(newValue);

    try {
      const projectId = newValue && typeof newValue === 'object' ? newValue.value : null;

      if (projectId) {
        // Clear the taskOptions before fetching new tasks
        setStageDropdown([]);
        setSelectStageDropdown(null);
        // Increment the key to force remounting of the Select component
        setTaskKey(prevKey => prevKey + 1);

        // Fetch tasks here based on the selected project ID
        await fetchStage(projectId);
      } else {
        console.error('Invalid or missing project ID');
      }
    } catch (error) {
      console.error('Error fetching tasks:', error);
      // Handle errors if needed
    }
  };






  return (
    <div>
      {isLoading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
          <ClockLoader color={"#4e73df"} loading={isLoading} css={spinnerStyle} size={100} />
        </div>
      ) : (

        <Container fluid>
          <br/>
          <Row >
            <Col>
              <Row className="mb-4">
                <Col>
                  <Widget>
                    <div style={{ padding: "20px" }}>
                       <div className="headline-2" style={{color : "blue"}}>Audit Search Filter
                        <div style={{ float: "right" }}>
                          <button type="button" className="btn btn-primary" onClick={openmodel}>Add</button> &nbsp;
                          <button type="button" className="btn btn-primary" onClick={handleSearch}>
                            <FontAwesomeIcon icon={faSearch} style={{ marginRight: '5px' }} />
                            Search
                          </button> &nbsp;
                          <button type="button" className="btn btn-primary" onClick={handleCancel}>
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="row" style={{ whiteSpace: 'nowrap' }}>
                      {/* <div className="col-sm-3">

                        <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required ">User</label>
                        <div style={{ marginLeft: "3px", padding: "10px" }}>
                        <Select
                                        classNamePrefix="select2-selection"
                                        placeholder="Choose..."
                                        title="Asset Form"
                                        options={staffname}
                                        value={selectedstaff}
                                        onChange={(selectedOption) => {
                                            setSelectedstaff(selectedOption ? selectedOption : null);
                                        }} 
                                        isDisabled={isRoleTwo}
                                    />
                        </div>
                      </div> */}
                      {/* <div className="col-sm-3">
                        <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required">Department</label>
                        <div style={{ marginLeft: "3px", padding: "10px" }}>
                        <Select
                              classNamePrefix="select2-selection"
                              placeholder="Choose..."
                              title="Asset Form"
                              options={departmentDropdown}
                              value={selecteddepartment}
                              onChange={setSelecteddepartment}
                            />
                        </div>
                      </div> */}
                      {/* <div className="col-sm-3">

                        <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required">Customer</label>
                        <div className="row-sm-3" style={{ padding: "10px" }}>
                          <Select
                            classNamePrefix="select2-selection"
                            placeholder="Choose..."
                            title="Asset Form"
                            options={customeDropdown}
                            value={selectCustomeDropdown}
                            onChange={setSelectCustomeDropdown}
                          />

                        </div>
                      </div> */}
                      <div className="col-sm-4">

                        <label htmlFor="assetCode" className="col-sm-4 col-form-label label-required">Project</label>
                        <div className="row-sm-3" style={{ marginRight: '5px', padding: "10px" }}>
                          <Select
                            classNamePrefix="select2-selection"
                            placeholder="Choose..."
                            title="Asset Form"
                            options={tPorjectDropdown}
                            value={selectTPorjectDropdown}
                            onChange={handelprojectChange}
                          />
                        </div>

                      </div>

                      <div className="col-sm-4">

<label htmlFor="assetCode" className="col-sm-4 col-form-label label-required">Task</label>
<div className="row-sm-3" style={{ marginRight: '5px', padding: "10px" }}>
  <Select
    classNamePrefix="select2-selection"
    placeholder="Choose..."
    title="Asset Form"
    options={stageDropdown}
    value={selectStageDropdown}
    onChange={setSelectStageDropdown}
  />
</div>

</div>

                      <div className="col-sm-4">

                        <label htmlFor="assetCode" className="col-sm-4 col-form-label label-required">Status</label>
                        <div className="row-sm-3" style={{ marginRight: '5px', padding: "10px" }}>
                          <Select
                            classNamePrefix="select2-selection"
                            placeholder="Choose..."
                            title="Asset Form"
                            options={optionsStatus}
                            value={selectedValueStatus}
                            onChange={setSelectedValueStatus}
                          />
                        </div>

                      </div>
                     
                      
                      <div className="col-sm-4">

                        <label htmlFor="assetCode" className="col-sm-4 col-form-label label-required">Registered Start Date
                        </label>
                        <div className="row-sm-3" style={{ marginRight: '5px', padding: "10px" }}>
                          <DatePicker
                            type="text"
                            className=" form-control custom-datepicker"
                            wrapperClassName="custom-datepicker-wrapper"
                            selected={selectedDate}
                            onChange={handleDateChange}
                            dateFormat="dd/MM/yyyy"
                            placeholderText="Start a date"

                            selectsStart
                            showYearDropdown
                            scrollableYearDropdown
                          />
                        </div>

                      </div>
                      <div className="col-sm-4">

                        <label htmlFor="assetCode" className="col-sm-4 col-form-label label-required">Registered End Date</label>
                        <div className="row-sm-3" style={{ marginRight: '5px', padding: "10px" }}>
                          <DatePicker
                            type="text"
                            className=" form-control custom-datepicker"
                            wrapperClassName="custom-datepicker-wrapper"
                            selected={endDate} // Replace with your state variable for the selected date
                            onChange={handleDateChange2}
                            dateFormat="dd/MM/yyyy"
                            placeholderText="Select a date"
                            selectsEnd
                            showYearDropdown
                            scrollableYearDropdown
                          />
                        </div>

                      </div>
                    </div>



                  </Widget>
                </Col>
              </Row>
            </Col>
          </Row>


        
          <div>

            <Row>
              <Col>
                <Row className="mb-4">
                  <Col>
                    <Widget>
                      <div style={{ padding: "20px" }}>
                         <div className="headline-2" style={{color : "blue"}}>Audit</div>
                      </div>
                      <div className="widget-table-overflow">
                        <Table className="table-striped table-borderless table-hover" responsive>
                          <thead>
                            <tr style={{ whiteSpace: 'nowrap' }}>
                              <th>Audit No</th>
                              {/* <th>Customer Name</th> */}
                              <th>Issue Description</th>
                              <th>User</th>
                              <th>Project</th>
                              <th>Task [Stage]</th>
                              <th>Location</th>
                              <th>Register</th>
                              <th>Date</th>
                              <th>Status</th>


                            </tr>
                          </thead>
                          <tbody style={{ whiteSpace: 'nowrap' }}>
                            {data && data.length > 0 ? (
                              data
                                .slice(secondTableCurrentPage * pageSize, (secondTableCurrentPage + 1) * pageSize)
                                .map((item, index) => (
                                  <tr key={index.id}>
                                    <td>{item.auditrefno}</td>
                                    {/* <td>{item.customername}</td> */}
                                    <td>{item.auditremarks}</td>
                                    <td>{item.username}</td>
                                    <td>{item.entityname}</td>
                                    <td>{item.tasktitle}</td>
                                    <td>{item.location}</td>
                                    <td>{item.regdate}</td>
                                    <td>{item.auditcompdate}</td>
                                    {/* <td>{item.status}</td> */}
                                    <td><Badge style={{
                                      backgroundColor:


                                        item.status === 'Planned' ? 'blue' :
                                          item.status === 'Completed' ? 'Green' :
                                            item.status === 'Registered' ? '#720e9e' :
                                              item.status === '' ? 'black' : 'white',
                                    }}>{item.status}</Badge>
                                    </td>

                                    {/* <td> <button className="btn btn-primary"
                                      style={{ padding: "5px 10px", fontSize: "12px" ,  whiteSpace: 'nowrap'  }} onClick={() => auditopenid(item.id)}>To Re-open</button>
                                    </td> */}
                                  </tr>
                                ))
                            ) : (
                              <tr>
                                <td colSpan="9" style={{ textAlign: "center", color: "red" }}>
                                  No data available
                                </td>
                              </tr>
                            )}

                          </tbody>
                        </Table>
                        <div style={{ textAlign: "left", marginTop: "20px" }}>
                          <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                            Total Audit: <span style={{ color: "blue" }}>{data ? data.length : 0}</span>
                          </p>
                        </div>
                        <PaginationComponent />
                      </div>
                    </Widget>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </Container>

      )}

      <Modal isOpen={auditOpen} toggle={auditClosed}>
        <ModalHeader toggle={auditClosed}>Service Reopen Confirmation</ModalHeader>
        <ModalBody>
          <div>
            <label>Remarks:</label>
            <textarea className="form-control" rows="4"
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}></textarea>
          </div>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-center">
          <Button color="secondary" onClick={auditClosed}>
            No
          </Button>
          <Button color="danger" onClick={handleAuditReopen}>
            Re-Open
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={isModalOpen} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Audit Log Add</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-6">
              <Form>
                {/* <FormGroup>
                  <Label for="register">Customer</Label>
                  <Select
                    classNamePrefix="select2-selection"
                    placeholder="Choose..."
                    title="Asset Form"
                    options={customeOption}
                    value={selectedcustome}
                    onChange={setselectedcustome}
                  />
                </FormGroup> */}
                <FormGroup>
                  <Label for="assignedStaff">Select Project</Label>
                  <Select
                    classNamePrefix="select2-selection"
                    placeholder="Choose..."
                    title="Asset Form"
                    options={productOptions}
                    value={selectedProduct}
                    onChange={handleProductChange}
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="completed">Select Task</Label>
                  <Select
                    classNamePrefix="select2-selection"
                    placeholder="Choose..."
                    title="Asset Form"
                    options={taskOptions}
                    value={selectedtask}
                    onChange={setselectedTask}
                    key={taskKey}
                  />
                </FormGroup>
              </Form>
            </div>
            <div className="col-md-6">
              <Form>

               
                <FormGroup>
                  <Label for="completedRemark">Remark / Issue</Label>
                  <Input
                    type="textarea"
                    name="RemarkIssue"
                    id="remarkissue"
                    value={Remarktext}
                    onChange={(e) => setRemarktext(e.target.value)}

                  />
                </FormGroup>
              </Form>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-primary" onClick={handleSubmit}>
            Submit
          </button>
          <button className="btn btn-primary" onClick={toggleModal}>
            Cancel
          </button>
        </ModalFooter>
      </Modal>
      <ToastContainer />
    </div>



  )
}

const spinnerStyle = css`
display: block;
margin: 0 auto;
`;

export default Complaints;
